import React from 'react'
import { Grid, Form } from 'semantic-ui-react'

const ShopSchedules = ({obj, onChange}) => {
  let ttHours = {
    monday:    { open: '', close: '' },
    tuesday:   { open: '', close: '' },
    wednesday: { open: '', close: '' },
    thursday:  { open: '', close: '' },
    friday:    { open: '', close: '' },
    saturday:  { open: '', close: '' },
    sunday:    { open: '', close: '' }
  }

  if (obj.ttHours) {
    Object.keys(obj.ttHours).forEach((objectKey, index) => {
      if (obj.ttHours[objectKey]) {
        ttHours[objectKey].open = obj.ttHours[objectKey].open
        ttHours[objectKey].close = obj.ttHours[objectKey].close
      }
    })
  }

  return (
    <div>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            Lundi
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[monday][open]" value={ttHours.monday.open} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[monday][close]" value={ttHours.monday.close} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            Mardi
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[tuesday][open]" value={ttHours.tuesday.open} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[tuesday][close]" value={ttHours.tuesday.close} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            Mercredi
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[wednesday][open]" value={ttHours.wednesday.open} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[wednesday][close]" value={ttHours.wednesday.close} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            Jeudi
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[thursday][open]" value={ttHours.thursday.open} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[thursday][close]" value={ttHours.thursday.close} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            Vendredi
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[friday][open]" value={ttHours.friday.open} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[friday][close]" value={ttHours.friday.close} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            Samedi
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[saturday][open]" value={ttHours.saturday.open} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[saturday][close]" value={ttHours.saturday.close} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            Dimanche
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[sunday][open]" value={ttHours.sunday.open} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
          <Grid.Column>
            <Form.Field>
              <Form.Input type="time" id="ttHours[sunday][close]" value={ttHours.sunday.close} onChange={onChange} />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default ShopSchedules



// WEBPACK FOOTER //
// ./src/components/form/shop/schedules.js